








import { Component, Vue } from 'vue-property-decorator';
import { BitfinexModule } from '@/store/modules/bitfinex';
import MarketDataCard from './MarketDataCard.vue';

@Component({
  name: 'BitfinexFundingRate',
  components: {
    MarketDataCard,
  },
  filters: {
    anual(value: number) {
      if (value) {
        const annualInterest = Math.pow(1 + value, 365) - 1;
        const percent = (Math.round(annualInterest * 1000) / 10).toFixed(1);
        return percent + '%yr';
      }
      return 'Loading...';
    },
  },
})
export default class BitfinexFundingRate extends Vue {
  get loaded() {
    return BitfinexModule.usdFrr > 0 || BitfinexModule.btcFrr > 0;
  }
  get btcFrr() {
    return BitfinexModule.btcFrr;
  }
  get usdFrr() {
    return BitfinexModule.usdFrr;
  }
}
